<template>
  <span class="b44-matriz-badge" :class="[cfg.className, size === 'md' ? 'md' : 'sm']">
    {{ cfg.label }}
  </span>
</template>

<script>
const CONFIG = {
  intervir: { label: "INTERVIR", className: "intervir" },
  agir: { label: "AGIR", className: "agir" },
  ideal: { label: "IDEAL", className: "ideal" },
  apoiar: { label: "APOIAR", className: "apoiar" },
  questionar: { label: "QUESTIONAR", className: "questionar" },
  cancelar: { label: "CANCELAR", className: "cancelar" },
  sem_classificacao: { label: "—", className: "sem" },
};

export default {
  name: "MatrizBadge",
  props: {
    classificacao: { type: String, default: "sem_classificacao" },
    size: { type: String, default: "sm" },
  },
  computed: {
    cfg() {
      return CONFIG[this.classificacao] || CONFIG.sem_classificacao;
    },
  },
};
</script>
